((Drupal, drupalSettings) => {
  Drupal.kafHelper = Drupal.kafHelper || {};
  Drupal.kafHelper = {
    throttle: (callback, delay) => {
      let isThrottled = false,
        args,
        context;

      function wrapper() {
        if (isThrottled) {
          args = arguments;
          context = this;
          return;
        }

        isThrottled = true;
        callback.apply(this, arguments);

        setTimeout(() => {
          isThrottled = false;
          if (args) {
            wrapper.apply(context, args);
            args = context = null;
          }
        }, delay);
      }

      return wrapper;
    },
    checkIndex: index => {
      const host = window.location.host;
      if (!host || !index) {
        return index;
      }
      if (drupalSettings.kaf_search.is_prod) {
        return index;
      } else {
        return `dev_${index}`;
      }
    },
  };
})(Drupal, drupalSettings);
